import cn from 'classnames';

import Subheading from 'components/common/Subheading';
import Text from 'components/common/Text';
import BoxToggle from 'components/signUpFunnel/intro/BoxToggle';
import { HOME_CHEF } from 'context/BrandContext';
import useBrand from 'hooks/useBrand';

const Questions = ({ handleMealKitTraitClick, isFamilyLead, visibleMealKitTraits }) => {
  const isHomeChef = useBrand(HOME_CHEF);

  const getQuestionText = () => {
    if (isFamilyLead) {
      return 'What can we help you with?';
    } else if (isHomeChef) {
      return 'What kind of meals are you interested in?';
    } else {
      return 'What are your goals?';
    }
  };

  const IntroQuestion = () => (
    <Subheading
      className={cn(
        { 'font-semibold': isHomeChef, 'text-tempo-black-100': !isHomeChef },
        'mb-2 mt-0 text-left bp1:mt-10'
      )}
      brandStylesOverrides={!isHomeChef ? 'h5' : ''}
    >
      {getQuestionText()}
    </Subheading>
  );

  return (
    <>
      <section data-testid="intro-questions">
        <IntroQuestion />
        <div className="grid grid-cols-2 flex-row flex-wrap items-start gap-2 p-0 bp2:grid-cols-3">
          {visibleMealKitTraits &&
            visibleMealKitTraits
              .filter(({ traitType }) => traitType === 'Cooking Goal' || traitType === 'Experience')
              .map(({ friendlyName, selected, description, icon }) => (
                <BoxToggle
                  key={friendlyName}
                  id={friendlyName}
                  name={friendlyName}
                  handleClick={() => handleMealKitTraitClick({ friendlyName, selected })}
                  selected={selected}
                  icon={icon}
                >
                  {friendlyName}
                  {description && <Text className="mt-1">{description}</Text>}
                </BoxToggle>
              ))}
        </div>
      </section>
    </>
  );
};

Questions.propTypes = {
  handleMealKitTraitClick: PropTypes.func.isRequired,
  visibleMealKitTraits: PropTypes.array.isRequired,
  isFamilyLead: PropTypes.bool.isRequired,
};

export default Questions;
